const id = {
  language: {
    zh: '中文',
    en: 'English',
    id: 'Indonesia',
    th: 'ภาษาไทย'
  },
  dialog: {
    tips: 'Peringatan jenis',
    confirm: 'Konfirmasi',
    cancel: 'Batalkan',
  },
  error: {
    tips_1: 'Ada sedikit ketidakcocokan dalam layanan',
    tips_2: 'Sepertinya kita tidak bisa menemukan sumber daya lagi',
    tips_3: 'Operasi gagal, tolong hubungi pedagang',
  },
  bindings: {
    deviceBinding: 'Pengikatan perangkat',
    tips: 'Tip',
    tipsContent: 'Silakan masukkan nomor perangkat untuk mengikat perangkat. Anda dapat memeriksa penggunaan data kapan saja',
    device: 'Nomor perangkat',
    deviceTips: 'Silakan masukkan nomor perangkat',
    searchHistory: 'Sejarah pencarian',
    searches: 'Pencarian',
    binding: 'Mengikat',
    imeiTips: 'Silakan masukkan nomor perangkat '
  },
  xinXunIndex: {
    deviceManagement: 'Manajemen perangkat',
    onlineDevice: 'Perangkat online',
    currentNetwork: 'Rangkaian saat ini',
    signalStrength: 'intensitas sinyal',
    online: 'Online',
    offline: 'Offline',
    switchingDevices: 'Berpindah perangkat',
    daysRemaining: 'Hari tersisa',
    usedData: 'Data yang digunakan',
    toady: "Penggunaan hari ini",
    total: 'Total',
    rechargeAndPay: 'Isi ulang dan bayar',
    myPackage: 'Paket saya',
    customerService: 'Layanan pelanggan',
    change: 'Ubah nama dan kata sandi',
    hotspotName: 'Nama Hotspot',
    password: 'Kata sandi WIFI',
    saveChanges: 'Simpan perubahan',
    status: 'Status',
    language: 'Bahasa',
    wifiName: 'Nama tidak dapat kosong',
    wifiPassword: 'Kata sandi tidak dapat kosong',
    wifiTips: 'Ingatan jenis: Setelah pengubahan berhasil, silakan memulai ulang perangkat. Pengubahan rekening jauh dan kata sandi membutuhkan waktu menunggu 3-5 menit. Silakan bersabar.',
  },
  usage: {
    myPackage: 'Paket saya',
    currentPackage: 'Paket saat ini',
    packageRenewalHistory: 'Riwayat perpanjangan paket',
    rechargeAndPay: 'Isi ulang dan bayar',
    effectiveDate: 'Tanggal efektif',
    expirationDate: 'Tanggal habis tempo',
    useData: 'Penggunaan data paket saat ini',
    orderNumber: 'Nomor pesanan',
    received: 'Diterima',
    processing: 'Sedang diproses',
    unknown: 'Tidak diketahui'
  },
  planList: {
    home :'Halaman rumah',
    packageList: 'Daftar paket',
    monthlyAverage: 'Rata-rata bulanan',
    validityPeriod: 'Periode validitas',
    days: 'Hari',
    unlimited: 'Tak terbatas',
    longTerm: 'Efektivitas jangka panjang',
    tips_1: 'Perangkat ini saat ini tidak memiliki paket muat ulang. Silakan kontak layanan pelanggan toko',
    tips_2: 'Perangkat ini saat ini tidak memiliki paket muat ulang. Silakan hubungi layanan pelanggan untuk proses tepat waktu',
    newUserOffer: 'Promo Pemula'
  },
  packageDetails: {
    packageDetails: 'Rincian paket',
    data: 'Data',
    packageDescription: 'Deskripsi paket',
    rechargeNow: 'Isi ulang sekarang'
  },
  recharge: {
    payNow: 'Bayar sekarang',
    // unit: 'IDR',
    unit: '¥',
    paymentMethod: 'Cara pembayaran',
    onlinePayment: 'Pembayaran online',
    alipayPayment: 'Pembayaran melalui Alipay',
    weChatPayment: 'Pembayaran melalui Wechatpay',
    effectiveDate: 'Tanggal efektif',
    activateNow: 'Aktif sekarang ',
    selectDate: 'pilih tanggal',
    createOrderTip: 'Sedang membuat pesanan, mohon ditunggu sebentar'
  },
  qrCode: {
    tips_1: 'Anda harus memberikan izin akses kamera',
    tips_2: 'Tidak ada kamera di perangkat ini',
    tips_3: 'kamera ditempati',
    tips_4: 'Instalasi kamera tidak sesuai',
    tips_5: 'Pelayar ini tidak mendukung API streaming',
    tips_6: 'Konteks keamanan yang diperlukan (HTTPS, host lokal)',
  }
}
export default id